// extracted by mini-css-extract-plugin
module.exports = {"exercises":"_5DkSO0B1","top":"_5DgOGVhV","icon":"_5D12c_M7","titles":"_5D1fXMPs","title":"_5D24dK9x","subtitle":"_5DKM6onD","description":"_5DzsXEks"};